module.exports = __webpack_public_path__ + "static/GabrielaSeczkowska-0e2b5e29a8faf4ee9b68cdd5bb15e8f9.png";